'use strict';

var investorProfile = {
  age: 30,
  savings: 2500000
};

var assetClassReturns = {
  debt: 7,
  equity: 12
};

var returnProfiles = {
  SAFE: { label: 'Safe', equity: 20, debt: 80 },
  CONSERVATIVE: { label: 'Conservative', equity: 30, debt: 70 },
  REGULAR: { label: 'Regular', equity: 60, debt: 40 },
  GROW: { label: 'Grow', equity: 80, debt: 20 },
  ALLIN: { label: 'All in', equity: 100, debt: 0 }
};

var defaults = {
  retirement: {
    category: 'retirement',
    title: 'Retirement',
    icon: 'retirement',
    description: 'What’s your number? When can you stop relying on a salary to meet your expenses and for how long?',
    goalType: 'sequential',
    startingAllocation: 500000,
    currentSpend: 100000,
    spendFrequency: 12,
    spendStartAge: 60,
    spendStopAge: 90,
    investStartAge: 30,
    investStopAge: 60,
    regularInvestmentFrequency: 12,
    investmentPeriodReturn: 'REGULAR',
    spendingPeriodReturn: 'SAFE',
    customInvestmentPeriodEquity: null,
    customSpendingPeriodEquity: null,
    inflation: 5,
    scaling: true
  },
  education: {
    category: 'education',
    title: 'Education',
    icon: 'book',
    description: 'Prepare for the high costs of education - plan for a 5 year Medical college, 4 years US Ivy league or 2 year Masters degree.',
    goalType: 'sequential',
    startingAllocation: 1000000,
    currentSpend: 1000000,
    spendFrequency: 1,
    spendStartAge: 48,
    spendStopAge: 52,
    investStartAge: 30,
    investStopAge: 48,
    regularInvestmentFrequency: 12,
    investmentPeriodReturn: 'REGULAR',
    spendingPeriodReturn: 'SAFE',
    customInvestmentPeriodEquity: null,
    customSpendingPeriodEquity: null,
    inflation: 6,
    scaling: true
  },
  holidays: {
    category: 'holidays',
    title: 'Holidays',
    icon: 'holiday',
    description: 'Put those vacations on autopilot - India or Abroad | Luxury, Comfortable, Budget | From next year till 75',
    goalType: 'parallel',
    startingAllocation: 500000,
    currentSpend: 600000,
    spendFrequency: 1,
    spendStartAge: 40,
    spendStopAge: 70,
    investStartAge: 30,
    investStopAge: 60,
    regularInvestmentFrequency: 12,
    investmentPeriodReturn: 'REGULAR',
    spendingPeriodReturn: 'REGULAR',
    customInvestmentPeriodEquity: null,
    customSpendingPeriodEquity: null,
    inflation: 6,
    scaling: true
  },
  purchase: {
    category: 'purchase',
    title: 'Purchase',
    icon: 'purchase',
    description: 'Save and Invest towards that house downpayment, your wedding/honeymoon, a celebratory trip or luxury car.',
    goalType: 'sequential',
    startingAllocation: 0,
    currentSpend: 2500000,
    spendFrequency: 1,
    spendStartAge: 40,
    spendStopAge: 41,
    investStartAge: 30,
    investStopAge: 40,
    regularInvestmentFrequency: 12,
    investmentPeriodReturn: 'REGULAR',
    spendingPeriodReturn: 'REGULAR',
    customInvestmentPeriodEquity: null,
    customSpendingPeriodEquity: null,
    inflation: 5,
    scaling: true
  },
  freedom: {
    category: 'freedom',
    title: 'Freedom',
    icon: 'freedom',
    description: 'Build a fund to take a year off work, start a business or take that class you’ve always wanted to.',
    goalType: 'perpetual',
    startingAllocation: 25000,
    currentSpend: 1000,
    spendFrequency: 12,
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 30,
    investStopAge: 60,
    regularInvestmentFrequency: 12,
    investmentPeriodReturn: 'ALLIN',
    spendingPeriodReturn: 'ALLIN',
    customInvestmentPeriodEquity: null,
    customSpendingPeriodEquity: null,
    inflation: 0,
    scaling: true
  }
};

module.exports = {
  investorProfile: investorProfile,
  assetClassReturns: assetClassReturns,
  returnProfiles: returnProfiles,
  defaults: defaults
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/cmw-goaltools/dist/config/defaults.js
// module id = 213
// module chunks = 0